import { render } from "./ServicesView.vue?vue&type=template&id=1f0d665c&scoped=true"
import script from "./ServicesView.vue?vue&type=script&lang=js"
export * from "./ServicesView.vue?vue&type=script&lang=js"

import "./ServicesView.vue?vue&type=style&index=0&id=1f0d665c&scoped=true&lang=css"

import exportComponent from "C:\\Deployment\\Member Portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f0d665c"]])

export default __exports__